import React from 'react'
import './style.css'

const Redirect = () => {
  return (
    <div id='redirect'>
      <div id='redirectdiv'>
        Hey! I have just released my portfolio V2. Check it out as this is no longer up to date.
        <a href='https://hamaidamohamed.facila.dev/'>Portfolio V2</a>
      </div>
    </div>
  )
}

export default Redirect